
// THIS FILE IS AUTOGENERATED AS PART OF THE EXTENSION AND MODE PLUGIN PROCESS.
// IT SHOULD NOT BE MODIFIED MANUALLY 
const extensions = [];
const modes = [];

// Not required any longer
window.extensions = extensions;
window.modes = modes;

extensions.push("@nxt/extension-default");
extensions.push("@nxt/extension-cornerstone");
modes.push("@nxt/mode-longitudinal");
modes.push("@nxt/mode-segmentation");
modes.push("@nxt/mode-tmtv");
modes.push("@nxt/mode-microscopy");
modes.push("@nxt/mode-preclinical-4d");


// Add a dynamic runtime loader
async function loadModule(module) {
  if (typeof module !== 'string') return module;
  if( module==="@nxt/extension-default") {
    const imported = await import("@nxt/extension-default");
    return imported.default;
  }
  if( module==="@nxt/extension-cornerstone") {
    const imported = await import("@nxt/extension-cornerstone");
    return imported.default;
  }
  if( module==="@nxt/extension-measurement-tracking") {
    const imported = await import("@nxt/extension-measurement-tracking");
    return imported.default;
  }
  if( module==="@nxt/extension-cornerstone-dicom-sr") {
    const imported = await import("@nxt/extension-cornerstone-dicom-sr");
    return imported.default;
  }
  if( module==="@nxt/extension-cornerstone-dicom-seg") {
    const imported = await import("@nxt/extension-cornerstone-dicom-seg");
    return imported.default;
  }
  if( module==="@nxt/extension-cornerstone-dynamic-volume") {
    const imported = await import("@nxt/extension-cornerstone-dynamic-volume");
    return imported.default;
  }
  if( module==="@nxt/extension-dicom-microscopy") {
    const imported = await import("@nxt/extension-dicom-microscopy");
    return imported.default;
  }
  if( module==="@nxt/extension-dicom-pdf") {
    const imported = await import("@nxt/extension-dicom-pdf");
    return imported.default;
  }
  if( module==="@nxt/extension-dicom-video") {
    const imported = await import("@nxt/extension-dicom-video");
    return imported.default;
  }
  if( module==="@nxt/extension-tmtv") {
    const imported = await import("@nxt/extension-tmtv");
    return imported.default;
  }
  if( module==="@nxt/extension-test") {
    const imported = await import("@nxt/extension-test");
    return imported.default;
  }
  if( module==="@nxt/extension-cornerstone-dicom-rt") {
    const imported = await import("@nxt/extension-cornerstone-dicom-rt");
    return imported.default;
  }
  if( module==="@nxt/mode-longitudinal") {
    const imported = await import("@nxt/mode-longitudinal");
    return imported.default;
  }
  if( module==="@nxt/mode-segmentation") {
    const imported = await import("@nxt/mode-segmentation");
    return imported.default;
  }
  if( module==="@nxt/mode-tmtv") {
    const imported = await import("@nxt/mode-tmtv");
    return imported.default;
  }
  if( module==="@nxt/mode-microscopy") {
    const imported = await import("@nxt/mode-microscopy");
    return imported.default;
  }
  if( module==="@nxt/mode-preclinical-4d") {
    const imported = await import("@nxt/mode-preclinical-4d");
    return imported.default;
  }
  if( module==="@nxt/mode-test") {
    const imported = await import("@nxt/mode-test");
    return imported.default;
  }
  if( module==="@nxt/mode-basic-dev-mode") {
    const imported = await import("@nxt/mode-basic-dev-mode");
    return imported.default;
  }
  return (await import(/* webpackIgnore: true */ module)).default;
}

// Import a list of items (modules or string names)
// @return a Promise evaluating to a list of modules
export default function importItems(modules) {
  return Promise.all(modules.map(loadModule));
}

export { loadModule, modes, extensions, importItems };

